export default [
	{
		path: '/add-bot',
		name: 'AddBot',
		component: require('../pages/bots/bot.add.vue').default,
		meta: {
			navigationTitle: 'addBot'
		}
    },
	{
		path: '/bot/:botId',
		name: 'BotDetail',
		component: require('../pages/bots/bot.detail.vue').default,
		meta: {
			navigationSubTitle: 'parameter'
		}
	},
	{
		path: '/bot/:botId/variables',
		name: 'BotVariableList',
		component: require('../pages/botVariables/botVariable.list.vue').default,
		meta: {
			navigationSubTitle: 'variables'
		}
	},
	{
		path: '/bot/:botId/variables/:vairableId',
		name: 'BotVariableDetail',
		component: require('../pages/botVariables/botVariable.detail.vue').default,
		meta: {
			navigationSubTitle: 'variables'
		}
	},
	{
		path: '/bot/:botId/dashboard',
		name: 'Dashboard',
		component: require('../pages/bots/dashboard.vue').default,
		meta: {
			navigationSubTitle: 'dashboard'
		}
	},
	{
		path: '/bot/:botId/users',
		name: 'UsersList',
		component: require('../pages/users/user.list.vue').default,
		meta: {
			navigationSubTitle: 'users'
		}
	},
	{
		path: '/bot/:botId/userGroups',
		name: 'UserGroupList',
		component: require('../pages/userGroups/userGroup.list.vue').default,
		meta: {
			navigationSubTitle: 'userGroups'
		}
	},
	{
		path: '/bot/:botId/userGroups/:userGroupId',
		name: 'UserGroupDetail',
		component: require('../pages/userGroups/userGroup.detail.vue').default,
		meta: {
			navigationSubTitle: 'userGroups'
		}
	},
	{
		path: '/bot/:botId/usersLists',
		name: 'UserListList',
		component: require('../pages/userLists/userList.list.vue').default,
		meta: {
			navigationSubTitle: 'userLists'
		}
	},
	{
		path: '/bot/:botId/usersLists/:userListId',
		name: 'UserListDetail',
		component: require('../pages/userLists/userList.detail.vue').default,
		meta: {
			navigationSubTitle: 'userLists'
		}
	},
	{
		path: '/bot/:botId/users/:userId',
		name: 'UserDetail',
		component: require('../pages/users/user.detail.vue').default,
		meta: {
			navigationSubTitle: 'users'
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/bots.js